import { combineReducers } from "redux";
import filterReducer from "./filters/reducer";
import bookReducer from "./books/reducer";

const rootReducer = combineReducers({
    filters: filterReducer,
    books: bookReducer
});

export default rootReducer;
